import { render } from "./CompanySkeleton.vue?vue&type=template&id=11fbd16d&scoped=true"
const script = {}

import "./CompanySkeleton.vue?vue&type=style&index=0&id=11fbd16d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11fbd16d"]])

export default __exports__